import { useCallback } from "react";

import Router from "next/router";

import { QUERY_PARAMS, ROUTES } from "@utils/constants";

import { EMPTY_PAYMENT_METHOD, OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

type TSaveForLaterReturn = {
  saveForLater: () => void;
};

const useSaveForLater = (): TSaveForLaterReturn => {
  const { values, validateForm, setTouched } = useOrderFormik();

  const { saveShipment } = useOrderData();

  const saveForLater = useCallback(async () => {
    // Payment method is not required when saving order for later
    const newValues = { ...values, [OrderFields.PAYMENT_METHOD]: EMPTY_PAYMENT_METHOD };

    // Need to touch fields manually to show validation messages
    const touched = {};
    Object.keys(newValues).forEach((fieldName) => {
      touched[fieldName] = true;
    });
    setTouched(touched);

    const errors = await validateForm(newValues);

    if (Object.keys(errors).length > 0) {
      return;
    }

    const { isSuccess } = await saveShipment(newValues);

    if (isSuccess) {
      Router.push({ pathname: ROUTES.SHIPMENTS, query: { [QUERY_PARAMS.ORDER_CREATION_SUCCESS]: true } });
    }
  }, [saveShipment, setTouched, validateForm, values]);

  return { saveForLater };
};
export default useSaveForLater;
